export enum AppNames {
  rfp = 'RFP',
  pam_list = 'PAM LIST',
  pam_parameters = 'PAM PARAMETERS',
  customer_hierarchy = 'CUSTOMER HIERARCHY',
  dynamic_shipments = 'DYNAMIC SHIPMENTS',
  spot_quote = 'SPOT QUOTE',
  data_maintenance_tool = 'DATA MAINTENANCE TOOL',
}
